{
    "NAME": "DirectoryModal",
    "AddDirectoryTitle": "Add Directory",
    "ModifyDirectoryTitle": "Modify Directory",
    "TelServerFormLabel": "Telephone Server",
    "PartitionFormLabel": "Partition",
    "TelNumberFormLabel": "Telephone Number",
    "DescriptionFormLabel": "Description",
    "TelNumberFormLabel_Validation_Error": "Telephone Number is required",
    "DescriptionFormLabel_Validation_Error": "Description is required",
    "DirectoryAddModify_UnknownOrDeleted": "[Unknown or Deleted]",
    "DirectoryAddModify_ServerErrorTitle": "Validation errors",
    "DirectoryAddModify_ValidationWarning": "Please ensure all fields are filled in correctly",
    "DirectoryAddModify_ButtonHelpLabel": "Help?",
    "DirectoryAddModify_ButtonSubmitLabel": "Save",
    "DirectoryAddModify_ButtonCancelLabel": "Cancel",
    "DirectoryAddModify_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
    "DirectoryAddModify_PromptConfirm": "Yes",
    "DirectoryAddModify_TabsDetails": "Details",
    "DirectoryAddModify_PromptCancel": "Cancel"
}